import { Component } from '@angular/core';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';
import { CnafUserService, CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { ContacterMaCafCompletSharedComponent } from './contactermacafcomplet.shared.component';
import { TagXitiService } from '../services/tagxiti.service';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'cnaf-contactermacaf-complet-web',
    templateUrl: './contactermacafcomplet.component-web.html',
    styleUrls: ['./contactermacafcomplet.component.css', './contactermacafcomplet.component-web.css']
})
export class ContacterMaCafCompletWebComponent extends ContacterMaCafCompletSharedComponent {

    actionLien: (typeActionSpecifique: string) => boolean;

    constructor(
        _cnafContacterMaCafService: CnafContacterMaCafService,
        _cnafUserService: CnafUserService,
        _modalService: BsModalService,
        _cnafAtTagService: CnafAtTagService,
        _router: Router,
        _tagXitiService: TagXitiService) {
        super('web', _cnafContacterMaCafService, _cnafUserService, _modalService, _cnafAtTagService, _router, _tagXitiService);
        this.actionLien = this.cnafContacterMaCafService.actionLien;
    }

    onInit(): void {
        // Pour web, rien à faire de spécifique
    }

    getActionLienService(s: string): void {
        this.cnafContacterMaCafService.actionLien(s);
    }
}
